import React from "react";
import {
  Artwork as ArtworkSlider,
  Galleries as GalleriesSlider,
} from '../common/container/Slider.jsx';
import { Title } from '../common/container/Container.jsx';
import Arrows from '../common/input/Arrows.jsx';
import { publicCompany } from '../common/publicCompany.ts';

class NotFound extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const browseTitleContent = (
      <Title className="section__title--small">
        <h2>Latest Artworks</h2>
        <Arrows display="See All" link="/browse" />
      </Title>
    );

    const galleryTitleContent = (
      <Title className="section__title--small">
        <h2>Newly Added Galleries</h2>
        <Arrows display="See All" link="/galleries" />
      </Title>
    );

    return (
      <React.Fragment>
        <div className="error__cont">
          <h1 className="error__title">404 Error</h1>
          <h2 className="error__title__sub">dagnabbit</h2>

          <div className="error__text">Lost?<br /><a href="/" >Back to {publicCompany(true)}</a></div>
        </div>
        <div className="section section--browse">
          <ArtworkSlider
            id="browse"
            q={{
              limit: 30,
              offset: 0,
              type: 'Artwork'
            }}
            slideProps={{
              height: 250,
              onLikeChange: this.handleArtworkLikeChange,
            }}
            titleContent={browseTitleContent}
            url={Artcloud.url.vendor.marketplace.art.get()}
          />
        </div>

        <div className="section section--gallery">
          <GalleriesSlider
            id="galleries"
            q={{ limit: 30, offset: 0, type: 0 }}
            slideProps={{ height: 250, setWidth: false, index: 5 }}
            titleContent={galleryTitleContent}
            url={Artcloud.url.vendor.marketplace.galleries.get()}
          />
        </div>
      </React.Fragment>
    )
  }
}

export default NotFound;